<template>
    <simple-btn class="lead-form-wrapper__download" :facets="['primary', 'medium', 'has-grid']" @click="openLeadFormOverlay">
        Factsheet herunterladen
        <ui-icon size="medium" symbol="download"/>
    </simple-btn>
</template>

<script>
    import { mapActions } from 'vuex';
    import SimpleBtn from '../../components/buttons/simple-btn/simple-btn';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import LeadFormOverlay from '../lead-form-overlay/lead-form-overlay.vue';
    import Vue from 'vue';

    Vue.component('LeadFormOverlay', LeadFormOverlay);

    export default {
        components: {
            SimpleBtn,
            UiIcon,
        },
        props: {
            servicename: {
                type: String,
                required: true,
            },
            serviceid: {
                type: String,
                required: true,
            },
            contact: {
                type: String,
                required: true,
            },
            csrf: {
                type: String,
                required: true,
            },
        },
        methods: {
            ...mapActions('vue-ui/overlay', ['openOverlay', 'closeOverlay']),
            openLeadFormOverlay() {
                this.openOverlay({
                    id: 'LEAD_FORM_OVERLAY',
                    transition: 'trs-simple-fade',
                    component: 'LeadFormOverlay',
                    props: {
                        close: this.closeOverlay,
                        title: this.servicename,
                        csrf: this.csrf,
                        service: this.serviceid,
                        contact: this.contact,
                    },
                });
            },
        },
        
    };
</script>
